'use client';

import SvgRotateRight from '@hc-frontend/core-icons/kit/rotate-right';
import { addClassName } from '@hc-frontend/core-utils-format';

export function SpinnerInline() {
  return (
    <div
      className={addClassName(
        'hc-icon-layout__sprite relative animate-spin mx-4-4',
      )}
    >
      <SvgRotateRight />
    </div>
  );
}
